import * as React from 'react';
import { RouteComponentProps } from 'react-router';

export namespace Start {
	export interface Props extends RouteComponentProps<void> {
		start: () => void;
	}

	export interface State {

	}
}

export const StartOverlay: React.SFC<Start.Props> = (props) => {
	return (
		<div className="am_overlay" onClick={props.start}>
			Aloita painamalla tästä<br/><br/>
			<img src="/images/Play.png"/>
		</div>
	);
}


// WEBPACK FOOTER //
// ./~/tslint-loader!./react/narrapix/src/containers/Play/start.tsx